import { AnimateLayoutChanges, defaultAnimateLayoutChanges, useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { PropsWithChildren } from 'react'
import { twMerge } from 'tailwind-merge'
import { DragIcon } from '@systemeio/ui'

const animateLayoutChanges: AnimateLayoutChanges = args =>
  defaultAnimateLayoutChanges({ ...args, wasDragging: true })

interface ItemWrapperProps extends PropsWithChildren {
  id: number | string
  iconClassName?: string
  className?: string
}

const ItemWrapper = ({ children, id, iconClassName, className }: ItemWrapperProps) => {
  const { attributes, isDragging, listeners, setNodeRef, transition, transform } = useSortable({
    id: id,
    animateLayoutChanges,
  })

  const style = {
    transition,
    transform: CSS.Translate.toString(transform),
    opacity: isDragging ? 0.5 : undefined,
  }
  return (
    <div
      className={twMerge('flex cursor-grab items-center gap-3', className)}
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
    >
      <DragIcon className={twMerge('shrink-0', iconClassName)} />
      {children}
    </div>
  )
}
export default ItemWrapper
